import styled from 'styled-components';

const SVG_Wrapper = styled.div`
    color: ${({ isSelected, theme }) =>  isSelected ? theme.palette?.secondary?.main: theme.palette?.leftMenuText?.color} !important;
    div {
        div {
            display: flex;
            justify-content: center;
        }
    }
`;

const SvgWrapper= styled.div `
    div {
        div {
            display: flex;
            justify-content: center;
        }
    }

`

const Wrapper = { SVG_Wrapper, SvgWrapper };

export default Wrapper;
